export default __webpack_public_path__ + "static/media/OLDMUTUALLOGO.f8a2e8cb.svg";